import { Injectable } from '@angular/core';

import { Observable, Observer, Subscriber } from 'rxjs';

import { LanguageService } from './language-service';
import { Network, Language } from './../data';
import { NetworkQuery } from './../queries';

@Injectable()
export class NetworkService {
  private mLang: Observable<string>;

  constructor(private languageService: LanguageService) {
    this.mLang = this.languageService.getCurrentLang();
  }

  public find() {
    return this.mLang.switchMap(lang => {
      return new NetworkQuery()
        .includeTranslation(Network.ICON_KEY, Language.DEFAULT_LANG)
        .includeTranslation(Network.ICON_KEY, lang)
        .rx()
        .find();
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/network-service.ts